import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            全部分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按类型快速找到你想看的内容</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-4 p-6 md:p-8 rounded-2xl bg-background-50 hover:bg-primary-500 cursor-pointer transition-all duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-background-50/20 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-2xl md:text-3xl`}></i>
              </div>
              <span className="font-heading font-semibold text-foreground-800 group-hover:text-background-50 transition-colors text-sm md:text-base">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}